module.exports = __webpack_public_path__ + "static/0chain_white_paper-34437549434039f993af27d5f925b0a4.png";